import { NotePaginatedResponse, NoteFilter } from '@/lead/types/LeadNoteTypes.ts';
import axios from '@/plugins/axios.js';
import { Pagination } from '@/types/Pagination.ts';

const baseUrl = 'v1/comments';

/**
 * Shared read transport for legacy Lead-page note hosts and Customer Profile note surfaces.
 * Collection ownership and post-write reconciliation remain host-specific during migration.
 */
const fetch = async (
    leadId: number,
    pagination: Pagination,
    filter: NoteFilter
): Promise<NotePaginatedResponse> => {
    const response = await axios.get(`${baseUrl}/${leadId}`, {
        params: {
            skip: pagination.skip,
            take: pagination.take,
            filter: filter.noteType?.[0],
            related: filter.related,
        },
    });

    return response.data;
};

export const LeadNotesService = {
    fetch,
};
